import { SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_REACTIVATE_SUBSCRIPTION_PATH_SUFFIX = "/reactivate";
/** /customer/subscription/reactivate */
export const SUBSCRIPTIONS_CUSTOMER_REACTIVATE_SUBSCRIPTION_PATH = `${SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH}${SUBSCRIPTIONS_CUSTOMER_REACTIVATE_SUBSCRIPTION_PATH_SUFFIX}`;
